export interface ErrorConfig<T> {
  [key: string]:
    | {
        getErrorKey: (error: T) => string | undefined;
        handleError: (error: T) => any;
        [key: string]: any;
      }
    | undefined;
}

export const createErrorHandler = <T>(errorConfig: ErrorConfig<T>) => {
  return (error: T) => {
    for (const key in errorConfig) {
      const config = errorConfig[key];
      if (!config) continue;

      const errorKey = config.getErrorKey(error);

      if (errorKey?.startsWith(key)) {
        return config.handleError(error);
      }
    }

    // Handle unknown errors
    return errorConfig.default?.handleError(error);
  };
};
